module.exports = __webpack_public_path__ + "img/fdtech03.b62db29b.png";